import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useEffectOnce } from 'react-use';
import updateVisibleHeightOfPromoBanner from 'commons/updateVisibleHeightOfPromoBanner';
import setPromoBannerVisibleHeightCssVar from 'commons/setPromoBannerVisibleHeightCssVar';
import removeNull from 'commons/removeNull';
import useUserData from 'data-hooks/useUserData';
import useIsBrowser from 'hooks/useIsBrowser';
import getDisplayDate from './helpers/getDisplayDate';
import PromotionContent from './components/PromotionContent';
const PromotionBanner = t0 => {
  const $ = _c(22);
  const {
    config: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const config = t2;
  const defaultValuesRef = useRef();
  const [isPromoBannerVisible, setIsPromoBannerVisible] = useState(true);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [displayValue, setDisplayValue] = useState(t3);
  const promoBannerRef = useRef();
  const {
    isTradeUser
  } = useUserData();
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (endDate, dateFormat, interval) => {
      const timeDiff = endDate.getTime() - Date.now();
      if (timeDiff > 0) {
        const displayValueUpdated = getDisplayDate(timeDiff, dateFormat);
        setDisplayValue(displayValueUpdated);
      } else {
        clearInterval(interval);
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const setTimeDiff = t4;
  let t5;
  if ($[4] !== config) {
    t5 = () => {
      defaultValuesRef.current = {
        textColor: "#dbeded",
        mainContent: "",
        subContent: "",
        endDate: new Date().toUTCString(),
        countDownFormat: "D H M S",
        secondaryBannerText: null
      };
      const endDate_0 = new Date(config ? config.endDate : defaultValuesRef.current.endDate);
      const dateFormat_0 = config ? config.countDownFormat : defaultValuesRef.current.countDownFormat;
      updateVisibleHeightOfPromoBanner();
      const updateHeightInterval = setInterval(_temp, 500);
      const interval_0 = setInterval(() => {
        setTimeDiff(endDate_0, dateFormat_0, interval_0);
      }, 1000);
      return () => {
        clearInterval(interval_0);
        clearInterval(updateHeightInterval);
      };
    };
    $[4] = config;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  useEffectOnce(t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setPromoBannerVisibleHeightCssVar(0);
      setIsPromoBannerVisible(false);
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const hidePromoBar = t6;
  const {
    textColor,
    mainContent,
    subContent,
    countdownToggle,
    backgroundImage,
    backgroundHeight,
    topBannerText
  } = config || defaultValuesRef.current;
  let t7;
  if ($[7] !== backgroundHeight) {
    t7 = backgroundHeight ? `${backgroundHeight.endsWith("px") ? backgroundHeight : `${backgroundHeight}px`}` : null;
    $[7] = backgroundHeight;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const promoStyleObj = {
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : null,
    height: t7
  };
  const isBrowser = useIsBrowser();
  const shouldShowCountdown = !!countdownToggle && isBrowser && displayValue.length > 0;
  const shouldHidePromotionTextUntilCountdownReady = !!countdownToggle && !shouldShowCountdown;
  if (!mainContent || !isPromoBannerVisible || isBrowser && isTradeUser) {
    return null;
  }
  const t8 = "PromotionBanner";
  const t9 = "items-center flex min-h-[55px] relative w-full z-[1003] max-[767px]:min-h-[70px] max-[767px]:pt-[5px] max-[767px]:px-0 max-[767px]:pb-2.5 bg-brand-dark";
  const t10 = removeNull(promoStyleObj);
  let t11;
  if ($[9] !== t10) {
    t11 = {
      ...t10
    };
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== displayValue || $[12] !== mainContent || $[13] !== shouldHidePromotionTextUntilCountdownReady || $[14] !== shouldShowCountdown || $[15] !== subContent || $[16] !== textColor || $[17] !== topBannerText) {
    t12 = <PromotionContent shouldShowCountdown={shouldShowCountdown} shouldHidePromotionTextUntilCountdownReady={shouldHidePromotionTextUntilCountdownReady} displayValue={displayValue} hidePromoBar={hidePromoBar} isCategoryNecessary={false} mainContent={mainContent} subContent={subContent} textColor={textColor} topBannerText={topBannerText} />;
    $[11] = displayValue;
    $[12] = mainContent;
    $[13] = shouldHidePromotionTextUntilCountdownReady;
    $[14] = shouldShowCountdown;
    $[15] = subContent;
    $[16] = textColor;
    $[17] = topBannerText;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <div data-xc={t8} className={t9} style={t11} ref={promoBannerRef}>{t12}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};
PromotionBanner.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    countDownFormat: PropTypes.string,
    endDate: PropTypes.string,
    mainContent: PropTypes.string,
    topBannerText: PropTypes.string,
    subContent: PropTypes.string,
    textColor: PropTypes.string
  })
};
export default PromotionBanner;
function _temp() {
  updateVisibleHeightOfPromoBanner();
}